import { httpClient } from '@/services/http/httpClient'

export async function createNewTennant({ name }: { name: string }) {
  await httpClient.post(`/tennants/`, { name })
}
